import filter from 'js/filter'
// 融资金额（年）、平均金额（年）、融资事件（年）
let year_option = {
  color: ['#2F54EB', '#40A9FF', '#80DEEA', '#1EA69B'],
  graphic: {
    type: 'image',
    style: {
      // image: require('../pic/default-logo.png'),
      image: require('../pic/watermark-white.png')
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    formatter: function (name) {
      if (name != '增长率') {
        return name.substring(0, 2)
      } else {
        return name
      }
    },
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    },
    legendselected: {
      type: 'legendselected',
      selected: {}
    },
    legendunselected: {
      type: 'legendselected',
      selected: {}
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 12,
    formatter: function (params, ticket, callback) {
      var name = params[0].name,
        seriesName = params[0].seriesName,
        dw = '',
        title = `<p class="p1">` + name + `年</p>`,
        q_html = '',
        r_html = '',
        t_html = ''


      let q1_index = params.findIndex((a) => a.seriesName.substring(0, 2) === 'Q1'),
        rate_index = params.findIndex((a) => a.seriesName === '增长率')

      if (rate_index > -1) {
        r_html = `<p class="p2">增长率：<span>` + params[rate_index].value + `%</span></p>`
      }

      if (q1_index > -1) {
        let type = seriesName.split('|')[0]
        if (type === 'Q1融资额' || type === 'Q1平均融资额') {
          dw = '亿' + filter.deal(seriesName.split('|')[1], 'unit')
        } else if (type === 'Q1事件数') {
          dw = '起'
        }
        t_html = `<p class="p2">` + params[5].seriesName + `：<span>` + params[5].value + dw + `</span></p>`
        q_html = `<p class="p2"><i class="cir_i" style="background-color: ` + params[3].color + `"></i>` + params[3].seriesName.split('|')[0] + `：<span>` + params[3].value + dw + `</span></p>
                  <p class="p2"><i class="cir_i" style="background-color: ` + params[2].color + `"></i>` + params[2].seriesName.split('|')[0] + `：<span>` + params[2].value + dw + `</span></p>
                  <p class="p2"><i class="cir_i" style="background-color: ` + params[1].color + `"></i>` + params[1].seriesName.split('|')[0] + `：<span>` + params[1].value + dw + `</span></p>
                  <p class="p2"><i class="cir_i" style="background-color: ` + params[0].color + `"></i>` + params[0].seriesName.split('|')[0] + `：<span>` + params[0].value + dw + `</span></p>`
      }
      return `<div class="chart_tip">` + title + t_html + r_html + q_html + `</div>`
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '60px',
    bottom: '0',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: ''
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '',
        width: 1
      }
    },
    axisLabel: {
      textStyle: {
        color: ''
      }
    }
  }],
  yAxis: [{
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: '#40444F',
        width: 1,
        type: 'dashed',
      }
    },
    min: 0,
    minInterval: 1
  }, {
    type: 'value',
    scale: true,
    axisLabel: {
      formatter: (val) => {
        return val + '%'
      },
      textStyle: {
        color: '#BCBDC1'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    minInterval: 1
  }],
  series: [{
    name: '',
    type: 'bar',
    barWidth: 30,
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: '#2F54EB'
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: '#40A9FF'
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: '#80DEEA'
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: '#1EA69C'
      }
    }
  },
  {
    name: '',
    type: 'line',
    yAxisIndex: 1,
    smooth: true,
    label: {
      normal: {
        show: true,
        position: 'top',
        formatter: function (params, ticket, callback) {
          return params.value + '%'
        },
        color: '#F89C95'
      }
    },
    symbolSize: 4,
    itemStyle: {
      normal: {
        color: '#F89C95',
      }
    },
    lineStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 1,
          y: 0,
          x2: 0,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: '#F89C95'
          }, {
            offset: 1,
            color: '#FCB290'
          }]
        }
      }
    },
    data: []
  },
  {
    name: '',
    type: 'line',
    symbol: 'rect',
    symbolSize: 1,
    hoverAnimation: false,
    itemStyle: {
      normal: {
        color: 'rgba(0,0,0,0)',
        borderWidth: 0
      }
    },
    lineStyle: {
      normal: {
        opacity: 0,
        borderWidth: 0
      }
    },
    label: {
      normal: {
        show: true,
        color: '#BCBDC1'
      }
    },
    data: []
  }
  ]
}
// 融资金额（季度）、平均金额（季度）、融资事件（季度）、热点领域事件/融资额
let option1 = {
  color: ['#30D3EF', '#F89C95'],
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    icon: "circle",
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    },
    selectedMode: false,
    legendselected: {
      type: 'legendselected',
      selected: {}
    },
    legendunselected: {
      type: 'legendselected',
      selected: {}
    },
    formatter: function (value) {
      return value.split('|')[0]
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params, ticket, callback) {
      let a_index = params.findIndex((a) => a.seriesName.split('|')[0] === '融资额'),
        v_index = params.findIndex((a) => a.seriesName.split('|')[0] === '平均融资额'),
        e_index = params.findIndex((a) => a.seriesName === '事件数'),
        r_index = params.findIndex((a) => a.seriesName === '增长率'),

        a_html = '',
        v_html = '',
        r_html = '',
        e_html = ''

      if (a_index > -1) {
        a_html = `<p class="p2">融资额：<span>` + params[a_index].value + `亿` + filter.deal(params[a_index].seriesName.split('|')[1], 'unit') + `</span></p>`
      }

      if (v_index > -1) {
        v_html = `<p class="p2">平均融资额：<span>` + params[v_index].value + `亿` + filter.deal(params[v_index].seriesName.split('|')[1], 'unit') + `</span></p>`
      }

      if (e_index > -1) {
        e_html = `<p class="p2">事件数：<span>` + params[e_index].value + `起</span></p>`
      }

      if (r_index > -1) {
        r_html = `<p class="p2">增长率：<span>` + params[r_index].value + `%</span></p>`
      }

      if (a_index > -1 || v_index > -1 || e_index > -1 || r_index > -1) {
        return `<div class="chart_tip">` + a_html + v_html + e_html + r_html + `</div>`
      }
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '40px',
    bottom: '20px',
    containLabel: true
  },
  graphic: {
    type: 'image',
    style: {
      // image: require('../pic/default-logo.png'),
      image: require('../pic/watermark-white.png'),
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: 'rgba(255,255,255,0.30)'
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#40444F',
        width: 1
      }
    },
    axisLabel: {
      interval: 0,
      textStyle: {
        color: '#797B83'
      }
    }
  }, {
    type: 'category',
    data: [],
    show: true,
    offset: -346,
    axisPointer: {
      type: 'line',
      lineStyle: {
        width: 0
      }
    },
    axisTick: {
      show: true,
      length: 45,
      lineStyle: {
        color: '#40444F'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    }
  }],
  yAxis: [{
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: '#40444F',
        width: 1,
        type: 'dashed',
      }
    },
    min: 0,
    minInterval: 1
  }, {
    type: 'value',
    scale: true,
    axisLabel: {
      formatter: (val) => {
        return val + '%'
      },
      textStyle: {
        color: '#BCBDC1'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    minInterval: 1
  }],
  series: [{
    name: '',
    type: 'bar',
    yAxisIndex: 0,
    barWidth: 18,
    itemStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: '#30D3EF'
          }, {
            offset: 1,
            color: '#31A8FD'
          }]
        },
        barBorderRadius: [2, 2, 0, 0]
      }
    },
    label: {
      normal: {
        show: false,
        position: 'top',
        color: '#BCBDC1'
      }
    },
    data: []
  },
  {
    name: '',
    type: 'line',
    yAxisIndex: 1,
    smooth: true,
    label: {
      normal: {
        show: false,
        position: 'top',
        formatter: function (params, ticket, callback) {
          return params.value + '%'
        },
        color: '#F89C95'
      }
    },
    itemStyle: {
      normal: {
        color: '#F89C95'
      }
    },
    lineStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 1,
          y: 0,
          x2: 0,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: '#F89C95'
          }, {
            offset: 1,
            color: '#FCB290'
          }]
        }
      }
    },
    data: []
  }
  ]
}
// 地域分布-国内地图
let option2 = {
  graphic: {
    type: 'image',
    style: {
      image: require('../pic/watermark-white.png'),
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  tooltip: {
    show: true,
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params) {
      // console.log(params)W
      var event = '',
        amount = ''
      if (params.data.value) {
        event = params.data.value
        amount = params.data.amount
        return `<div class="chart_tip">
                            <p class="p1">` + params.name + `</p>
                            <p class="p2">事件数：<span>` + event + `起</span></p>
                            <p class="p2">融资额：<span>` + amount + `亿美元</span></p>
                        </div>`
      } else {
        return `<div class="chart_tip">
                            <p class="p1">` + params.name + `</p>
                            <p class="p2">暂无相关数据</p>
                        </div>`
      }
    },
  },
  visualMap: {
    type: 'continuous',
    min: 0,
    max: 0,
    show: false,
    inRange: {
      color: ['#fffaf5', '#FC9C7C']
    }
  },
  geo: {
    map: 'china',
    label: {
      emphasis: {
        show: false
      }
    },
    itemStyle: {
      normal: {
        areaColor: '#fffaf5',
        borderColor: '#FC9C7C',
        opacity: 1
      },
      emphasis: {
        areaColor: '#FC9C7C',
        borderColor: '#fff',
        shadowColor: 'rgba(0, 0, 0, 0.3)',
        shadowBlur: 10,
        shadowOffsetY: 5
      }
    },
    zlevel: 1,
    top: '10px',
    left: '80px',
    right: '80px'
  },
  series: [{
    name: '融资事件',
    type: 'map',
    roam: false,
    geoIndex: 0,
    label: {
      show: false,
    },
    data: []
  }]
}
// 轮次分布
let option4 = {
  graphic: {
    type: 'image',
    style: {
      // image: require('../pic/default-logo.png'),
      image: require('../pic/watermark-white.png'),
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 12,
    formatter: function (params, ticket, callback) {
      var name = params[0].name
      var name2 = params[7].name

      var total_value = params[8].data
      //x轴名称
      //图表title名称
      var seriesName1 = params[0].seriesName
      var seriesName2 = params[1].seriesName
      var seriesName3 = params[2].seriesName
      var seriesName4 = params[3].seriesName
      var seriesName5 = params[4].seriesName
      var seriesName6 = params[5].seriesName
      var seriesName7 = params[6].seriesName
      // var seriesName8 = params[7].seriesName
      //比例
      var value1 = params[0].data
      var value2 = params[1].data
      var value3 = params[2].data
      var value4 = params[3].data
      var value5 = params[4].data
      var value6 = params[5].data
      var value7 = params[6].data
      // var value8 = params[7].data
      //数值
      var count1 = Math.round(value1 / 100 * total_value)
      var count2 = Math.round(value2 / 100 * total_value)
      var count3 = Math.round(value3 / 100 * total_value)
      var count4 = Math.round(value4 / 100 * total_value)
      var count5 = Math.round(value5 / 100 * total_value)
      var count6 = Math.round(value6 / 100 * total_value)
      var count7 = Math.round(value7 / 100 * total_value)
      // var count8 = Math.round(value8 / 100 * total_value)

      var title = ''
      if (name == name2) {
        title = `<p class="p1">` + name + `年</p>`
      } else {
        title = `<p class="p1">` + name2 + `年` + name + `</p>`
      }
      if (total_value > 0) {
        return `<div class="chart_tip">
                            ` + title + `
                            <p class="p2">融资事件数：<span>` + total_value + `起</span></p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[0].color + `"></i>` + seriesName1 + `：<span>` + value1 + `%</span>（` + count1 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[1].color + `"></i>` + seriesName2 + `：<span>` + value2 + `%</span>（` + count2 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[2].color + `"></i>` + seriesName3 + `：<span>` + value3 + `%</span>（` + count3 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[3].color + `"></i>` + seriesName4 + `：<span>` + value4 + `%</span>（` + count4 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[4].color + `"></i>` + seriesName5 + `：<span>` + value5 + `%</span>（` + count5 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[5].color + `"></i>` + seriesName6 + `：<span>` + value6 + `%</span>（` + count6 + `起）</p>
                            <p class="p2"><i class="cir_i" style="background-color: ` + params[6].color + `"></i>` + seriesName7 + `：<span>` + value7 + `%</span>（` + count7 + `起）</p>
                        </div>`
      }
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '40px',
    bottom: '0',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: 'rgba(255,255,255,0.30)'
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#40444F',
        width: 1
      }
    },
    axisLabel: {
      textStyle: {
        color: '#797B83'
      }
    }
  },
  {
    type: 'category',
    data: [],
    offset: -326,
    axisPointer: {
      type: 'line',
      lineStyle: {
        width: 0
      }
    },
    axisTick: {
      show: true,
      length: 45,
      lineStyle: {
        color: '#40444F'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    }
  },
  {
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        width: 0
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    }
  }
  ],
  yAxis: [{
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      },
      formatter: (obj) => {
        return obj + '%'
      },
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: '#40444F',
        width: 1,
        type: 'dashed',
      }
    },
    min: 0,
    max: 100,
    minInterval: 1
  },
  {
    type: 'value',
    scale: false,
    axisLabel: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  }
  ],
  series: [{
    name: '',
    type: 'bar',
    barWidth: 50,
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '',
    type: 'bar',
    stack: '总量',
    data: [],
    itemStyle: {
      normal: {
        color: ''
      }
    }
  },
  {
    name: '时间',
    type: 'line',
    xAxisIndex: 1,
    itemStyle: {
      normal: {
        opacity: 0,
        borderWidth: 0
      }
    },
    lineStyle: {
      normal: {
        opacity: 0,
        borderWidth: 0
      }
    },
    data: []
  },
  {
    name: '总数',
    type: 'line',
    xAxisIndex: 2,
    itemStyle: {
      normal: {
        opacity: 0,
        borderWidth: 0
      }
    },
    lineStyle: {
      normal: {
        opacity: 0,
        borderWidth: 0
      }
    },
    data: []
  }
  ]
}
// 地域分布-国外饼图-事件
let option5 = {
  graphic: {
    type: 'image',
    style: {
      // image: require('../pic/default-logo.png'),
      image: require('../pic/watermark-white.png'),
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  legend: {
    data: [],
    top: 'middle',
    align: 'left',
    left: '160px',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#bcbdc1',
      fontSize: 12
    }
  },
  tooltip: {
    trigger: 'item',
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params, ticket, callback) {
      return `<div class="chart_tip">
                <p class="p1">` + params.name + `</p>
                <p class="p2">事件数：<span>` + params.value + `起（` + params.percent + `%）</span></p>
              </div>`
    }
  },
  series: [{
    type: 'pie',
    radius: [34, 60],
    center: [80, 80],
    label: {
      normal: {
        show: false,
      }
    },
    data: []
  }]
}
// 地域分布-国外饼图-金额
let option6 = {
  graphic: {
    type: 'image',
    style: {
      // image: require('../pic/default-logo.png'),
      image: require('../pic/watermark-white.png'),
      // width: 150,
      // height: 150,
      // opacity: 0.4
    }
  },
  legend: {
    data: [],
    top: 'middle',
    align: 'left',
    left: '160px',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#bcbdc1',
      fontSize: 12
    }
  },
  tooltip: {
    trigger: 'item',
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params, ticket, callback) {
      return `<div class="chart_tip">
                <p class="p1">` + params.name + `</p>
                <p class="p2">融资额：<span>` + params.value + `亿` + filter.deal(params.seriesName.split('|')[1], 'unit') + `（` + params.percent + `%）</span></p>
              </div>`
    }
  },
  series: [{
    type: 'pie',
    radius: [0, 60],
    center: [80, 80],
    label: {
      normal: {
        show: false,
      }
    },
    data: []
  }]
}
// 地域分布-国内
let option7 = {
  color: ['#30D3EF', '#F89C95'],
  graphic: {
    type: 'image',
    style: {
      image: require('../pic/watermark-white.png'),
    }
  },
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    },
    formatter: function (value) {
      return value.split('|')[0]
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params, ticket, callback) {
      let a_index = params.findIndex((a) => a.seriesName.split('|')[0] === '融资额'),
        e_index = params.findIndex((a) => a.seriesName.split('|')[0] === '事件数'),
        a_html = '',
        e_html = ''
      if (a_index > -1) {
        a_html = `<p class="p2">融资额：<span>` + params[a_index].value + `亿` + filter.deal(params[a_index].seriesName.split('|')[1], 'unit') + `</span></p>`
      }

      if (e_index > -1) {
        e_html = `<p class="p2">事件数：<span>` + params[e_index].value + `起</span></p>`
      }

      return `<div class="chart_tip">` + a_html + e_html + `</div>`
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '80px',
    bottom: '0',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: 'rgba(255,255,255,0.30)'
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#40444F',
        width: 1
      }
    },
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      },
      formatter: ''
    }
  }],
  yAxis: [{
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: '#40444F',
        width: 1,
        type: 'dashed',
      }
    },
    min: 0,
    minInterval: 1
  }, {
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    minInterval: 1
  }],
  series: [{
    name: '',
    type: 'bar',
    yAxisIndex: 0,
    barWidth: 30,
    itemStyle: {
      normal: {
        color: '',
        barBorderRadius: [2, 2, 0, 0]
      },
    },
    label: {
      normal: {
        show: true,
        position: 'top',
        color: '#BCBDC1',
        formatter: function (params, ticket, callback) {
          return params.value
        }
      }
    },
    data: []
  },
  {
    name: '',
    type: 'line',
    yAxisIndex: 1,
    smooth: true,
    label: {
      normal: {
        show: true,
        position: 'top',
        formatter: function (params, ticket, callback) {
          return params.value
        },
        color: '#F89C95'
      }
    },
    symbolSize: 4,
    itemStyle: {
      normal: {
        color: '#F89C95',
      }
    },
    lineStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 1,
          y: 0,
          x2: 0,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: '#F89C95'
          }, {
            offset: 1,
            color: '#FCB290'
          }]
        }
      }
    },
    data: []
  }
  ]
}
// 投融资总趋势 - 领域分布
let field_option = {
  color: ['#30D3EF', '#F89C95'],
  graphic: {
    type: 'image',
    style: {
      image: require('../pic/watermark-white.png'),
    }
  },
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    },
    formatter: function (value) {
      return value.split('|')[0]
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 10,
    formatter: function (params, ticket, callback) {
      let a_index = params.findIndex((a) => a.seriesName.split('|')[0] === '融资额'),
        e_index = params.findIndex((a) => a.seriesName.split('|')[0] === '事件数'),
        a_html = '',
        e_html = ''
      if (a_index > -1) {
        a_html = `<p class="p2">融资额：<span>` + params[a_index].value + `亿` + filter.deal(params[a_index].seriesName.split('|')[1], 'unit') + `</span></p>`
      }

      if (e_index > -1) {
        e_html = `<p class="p2">事件数：<span>` + params[e_index].value + `起</span></p>`
      }

      return `<div class="chart_tip">` + a_html + e_html + `</div>`
    }
  },
  grid: {
    left: '0',
    right: '0',
    top: '80px',
    bottom: '40px',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisPointer: {
      type: 'line',
      lineStyle: {
        color: 'rgba(255,255,255,0.30)'
      }
    },
    axisTick: {
      show: false
    },
    splitLine: {
      show: false
    },
    axisLine: {
      lineStyle: {
        color: '#40444F',
        width: 1
      }
    },
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      },
      interval: 0,
      rotate: 30,
      formatter: ''
    }
  }],
  yAxis: [{
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    splitLine: {
      lineStyle: {
        color: '#40444F',
        width: 1,
        type: 'dashed',
      }
    },
    min: 0,
    minInterval: 1
  }, {
    type: 'value',
    scale: true,
    axisLabel: {
      textStyle: {
        color: '#BCBDC1'
      }
    },
    splitLine: {
      show: false
    },
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    },
    minInterval: 1
  }],
  series: [{
    name: '',
    type: 'bar',
    yAxisIndex: 0,
    barWidth: 30,
    itemStyle: {
      normal: {
        color: '',
        barBorderRadius: [2, 2, 0, 0]
      },
    },
    label: {
      normal: {
        show: true,
        position: 'top',
        color: '#BCBDC1',
        formatter: function (params, ticket, callback) {
          return params.value
        }
      }
    },
    data: []
  },
  {
    name: '',
    type: 'line',
    yAxisIndex: 1,
    smooth: true,
    label: {
      normal: {
        show: true,
        position: 'top',
        formatter: function (params, ticket, callback) {
          return params.value
        },
        color: '#F89C95'
      }
    },
    symbolSize: 4,
    itemStyle: {
      normal: {
        color: '#F89C95',
      }
    },
    lineStyle: {
      normal: {
        color: {
          type: 'linear',
          x: 1,
          y: 0,
          x2: 0,
          y2: 0,
          colorStops: [{
            offset: 0,
            color: '#F89C95'
          }, {
            offset: 1,
            color: '#FCB290'
          }]
        }
      }
    },
    data: []
  }
  ]
}

// 当前热点领域 - 多领域选择
let option8 = {
  legend: {
    data: [],
    top: '16px',
    left: '0',
    itemWidth: 10,
    itemHeight: 10,
    selectedMode: false,
    icon: "circle",
    textStyle: {
      color: '#BCBDC1',
      fontSize: 12
    }
  },
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#404040',
    padding: 12
  },
  grid: {
    left: '0',
    right: '5px',
    top: '60px',
    bottom: '20px',
    containLabel: true
  },
  graphic: {
    type: 'image',
    style: {
      image: require('../pic/watermark-white.png')
    }
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisPointer: {
        type: 'line',
        lineStyle: {
          color: 'rgba(255,255,255,0.30)'
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLine: {
        lineStyle: {
          color: '#40444F',
          width: 1
        }
      },
      axisLabel: {
        textStyle: {
          color: '#797B83'
        }
      }
    },
    {
      type: 'category',
      data: [],
      offset: -326,
      axisPointer: {
        type: 'line',
        lineStyle: {
          width: 0
        }
      },
      axisTick: {
        show: true,
        length: 45,
        lineStyle: {
          color: '#40444F'
        }
      },
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: '#BCBDC1'
        }
      }
    },
  ],
  yAxis: [
    {
      type: 'value',
      scale: true,
      axisLabel: {
        textStyle: {
          color: '#BCBDC1'
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        lineStyle: {
          color: '#40444F',
          width: 1,
          type: 'dashed',
        }
      },
      min: 0,
      minInterval: 1
    }
  ],
  series: []
}
export {
  option1,
  option2,
  option4,
  option5,
  year_option,
  option6,
  option7,
  field_option,
  option8
}
